import * as React from 'react';
import _ = require("lodash");
import './playeritemcomponent.css';
import CustomAutosuggest from "../CustomAutosuggest/index";
import RiotDB from "../../fbobjects/RiotDB";
import SimulationActions from "../../actions/SimulationActions";
import Player from "../../fbobjects/Player";
import SimItem from "../../fbobjects/ItemInfo";

interface PlayerItemComponentState {
    showAutosuggest: boolean;
}

interface PlayerItemComponentProps {
    item: any;
    level:number;
    player:Player;
}

export default class PlayerItemComponent extends React.Component<PlayerItemComponentProps,PlayerItemComponentState> {

    constructor(props:PlayerItemComponentProps){
        super(props);

        this.state={
            showAutosuggest: false,
        };
    }

    gp():PlayerItemComponentProps{
        return this.props;
    }

    handleOnItemClick(){
        this.setState({showAutosuggest:!this.state.showAutosuggest});
    }

    handleAutosuggestOnBlur(){
        if (this.state.showAutosuggest == true){
            this.setState({showAutosuggest:true})
        }

    }

    handleOnChooseItem(itemName){
        SimulationActions.addItem(this.gp().player, itemName, this.gp().level);
        if (this.state.showAutosuggest == true){
            this.setState({showAutosuggest:false})
        }
    }

    handleRemoveItem(){
        SimulationActions.removeItem(this.gp().player, this.gp().item)
    }

    renderItem(){
        let item = this.gp().item;
        if (item == 'add'){
            return <div className="add-item">+</div>
        }
        return <img src={RiotDB.getItemImgUrl(item.itemName)} className="item"/>
    }

    render() {
        return (
            <div style={{position:"relative"}} >
                <div className="player-item-container" onClick={()=>this.handleOnItemClick()} >
                    {this.renderItem()}
                </div>
                {this.state.showAutosuggest ?
                    <div className="suggest-or-delete-container">
                        <div className="delete" onMouseDown={()=>this.handleRemoveItem()}>
                            DELETE
                        </div>

                        <div className="autosuggest" autoFocus>
                            <CustomAutosuggest
                                onChoose={(itemName)=>{this.handleOnChooseItem(itemName)}}
                                suggestions={RiotDB.getItemNames()}
                                type={"item"}
                                defaultValue={"Search"}
                                onBlur={()=>this.handleAutosuggestOnBlur()}
                            />
                        </div>

                    </div>

                    : null
                }
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/PlayerItemComponent/index.tsx